
import { mapState, mapGetters, mapMutations } from 'vuex'
import { nextTick } from 'vue'

export default {
  data() {
    return {
      locationRoute: false,
      locationGated: false,
      completeProfile: true,
      goodToGo: false,
      deepLinkingProcessed: false
    }
  },
  computed: {
    ...mapState([
      'location',
      'loading',
      'errors',
      'showCart',
      'token',
      'orderConfirming',
      'shouldOpenConfirmLocationModal',
      'headerHeight',
      'order',
      'user',
      'channel',
      'global',
      'menu',
      'defaultMenu',
      'deeplinkProduct',
      'deeplinkProductNotFoundAtLocation'
    ]),
    ...mapGetters(['coldSignin']),
    mobile() {
      return this.$mq === 'sm' || this.$mq === 'md'
    },
    onMenu() {
      return (
        this.$route.name === 'order-product' ||
        this.$route.name === 'order-checkout' ||
        this.$route.name === 'order-items' ||
        this.$route.name === 'account-login'
      )
    },
    pageClass() {
      let pageClass = this.$route?.path ? this.$route.path.replace(/^\/|\/$/g, '').replace(/\//g, '-') : ''
      if (pageClass) {
        pageClass = 'page-'+pageClass
      } else {
        pageClass = 'page-home'
      }
      // Storyblok global page class e.g. boberry for temporary global changes
      let globalClass = Array.isArray(this.global) 
        ? this.global.find(i => i.name === 'Options')?.content?.options?.find(o => o.key === 'globalClass')?.value
        : null
      if (globalClass) {
        pageClass = pageClass+' '+globalClass
      }
      // Remove boberry-week from catering
      if (this.channel == 'catering' && globalClass) {
        globalClass = globalClass.replace(/\bboberry-week\b/, '').replace(/\s{2,}/g, ' ').trim()
        pageClass = pageClass.replace(/\bboberry-week\b/, '').replace(/\s{2,}/g, ' ').trim()
      }
      this.setGlobalClass(globalClass || null)
      return pageClass
    }
  },
  beforeCreate() {
    if (process.client) {
      const currentUrl = window.location.href;
      if (
        currentUrl === 'http://localhost:2001/' ||
        currentUrl === 'https://cateringsandbox--bojangles.netlify.app/' ||
        currentUrl === 'https://catering--bojangles.netlify.app/' ||
        currentUrl === 'https://catering.bojangles.com/'
      ) {
        // console.log('redirect', currentUrl)
        // window.location.assign('/locations');
      }
    }
  },
  beforeMount() {
    this.checkChannel()

    // For catering from app view, set a cookie
    if (this.$route.query.source === 'app') {
      document.cookie = `source=app; path=/;`
    }

    // Prevents unsightly outline on button click
    document.addEventListener('click', (e) => {
      if (e.target.closest('button')) {
        e.target.closest('button').blur()
      }
      if (e.target.parentElement?.closest('button')) {
        e.target.parentElement.closest('button').blur()
      }
    })
  },
  async mounted() {
    // Ensure page loads with scroll position at the top
    await nextTick(() => {
      window.scrollTo(0, 0)
    })
    
    this.checkChannel()

    if (this.location) {
      // Only fetch menu if not already in store
      if (!this.menu || !this.menu.categories || this.menu.categories.length === 0) {
        console.log('🔄 [Layout] Menu not in store, fetching...')
        await this.$api.getMenu(false)
      } else {
        console.log('✅ [Layout] Menu already in store, skipping fetch')
      }
    } else if (!this.location && this.channel === 'catering') {
      // Set a default catering menu id just to load homepage categories
      const data = await this.$api.getMenu(true, { menuId: '237039' })
      this.$store.commit('setMenu', data)
    }

    document.addEventListener('click', this.handleLinkClick)

    // Added Braze to the client's browser - allowing for testing through the console
    if(this.$braze) window.braze = this.$braze

    if (
      this.token &&
      (!this.token.provider || !this.token.provider.includes('oloauth'))
    ) {
      this.$api.logoutUser()
    }
    // if (!process.env.DISABLE_RECAPTCHA) {
    //   try {
    //     await this.$recaptcha.init()
    //   } catch (err) {
    //     console.error(err)
    //   }
    // }
    if (this.$route.query.store) {
      await this.$api.getLocation(this.$route.query.store)
      const order = await this.$api.createOrder()
      this.$store.commit('setOrder', order)
    }

    // ADA fixes
    const a = document.createElement('a')
    const s = document.body.firstChild
    const linkText = document.createTextNode('Skip to main content')
    a.appendChild(linkText)
    a.title = 'Skip to main content'
    a.href = '#main'
    a.className = 'skiplink'
    s.parentNode.insertBefore(a, s)
    if (this.$route.path === '/locations') {
      this.locationRoute = true
      setTimeout(function() {
        const map = document.querySelectorAll('iframe')[0]
        map.setAttribute('name', 'Google map of Bojangles Locations')
      }, 2000)
    }

    this.locationGated = !this.$store.state.user && !this.$store.state.location

    // Set header and footer heights in vuex on initial load and resize
    this.$nextTick(() => {
      this.setHeights()
      window.addEventListener('resize',this.setHeights)
    })

    // Handle product deep links after component is fully mounted
    this.handleDeepLinking()
  },
  destroyed() {
    document.removeEventListener('click', this.handleLinkClick);
    window.removeEventListener('resize',this.setHeights)
    window.removeEventListener('resize',this.setHeights)
  },
  methods: {
    ...mapMutations([ 'setChannel', 'setGlobalClass', 'setDeeplinkProduct', 'setDeeplinkProductNotFoundAtLocation', 'setShouldOpenConfirmLocationModal', 'setDeeplinkProductQuery' ]),
    findProductByQuery(productSlug) {
      if (!productSlug) return null
      
      // console.log('Searching for product:', productSlug)
      
      // Try current location menu first, then fall back to default menu
      let menu = this.menu
      let product = null
      
      if (menu?.categories) {
        // console.log('Searching in current location menu...')
        product = this.searchProductInMenu(productSlug, menu)
      }
      
      // If not found in current location menu, try default menu
      if (!product && this.defaultMenu?.categories) {
        // console.log('Searching in default menu...')
        product = this.searchProductInMenu(productSlug, this.defaultMenu)
      }
      
      if (product) {
        // console.log('Found product:', product.name)
      } else {
        // console.log('No product found for:', productSlug)
      }
      
      return product
    },
    searchProductInMenu(productSlug, menu) {
      if (!menu?.categories) return null

      // Normalize string for comparison
      const normalize = str => {
        return str
          .toLowerCase()
          .replace(/®/g, '')                  // strip symbols like ®
          .replace(/&/g, 'and')               // unify "&" → "and"
          .replace(/[^a-z0-9]+/g, '-')        // spaces/symbols → dashes
          .replace(/^-+|-+$/g, '')            // trim leading/trailing dashes
      }

      const target = normalize(productSlug)

      let bestMatch = null
      let bestScore = Infinity // lower score = better

      // Simple Levenshtein distance implementation
      const levenshtein = (a, b) => {
        const dp = Array.from({ length: a.length + 1 }, () =>
          Array(b.length + 1).fill(0)
        )

        for (let i = 0; i <= a.length; i++) dp[i][0] = i
        for (let j = 0; j <= b.length; j++) dp[0][j] = j

        for (let i = 1; i <= a.length; i++) {
          for (let j = 1; j <= b.length; j++) {
            if (a[i - 1] === b[j - 1]) {
              dp[i][j] = dp[i - 1][j - 1]
            } else {
              dp[i][j] = Math.min(
                dp[i - 1][j] + 1,    // deletion
                dp[i][j - 1] + 1,    // insertion
                dp[i - 1][j - 1] + 1 // substitution
              )
            }
          }
        }

        return dp[a.length][b.length]
      }

      for (const cat of menu.categories) {
        for (const product of cat.products) {
          // Clean product name by removing time data (everything after ' - ')
          const cleanName = product.name.split(' - ')[0].trim()
          const productSlug = normalize(cleanName)
          
          // console.log('Product:', product.name, 'Cleaned:', cleanName, 'Normalized:', productSlug, 'Target:', target)

          // Exact match, return immediately
          if (productSlug === target) {
            // console.log('Exact match found!')
            return product
          }

          // Otherwise, calculate similarity score
          const score = levenshtein(productSlug, target)
          if (score < bestScore) {
            bestScore = score
            bestMatch = product
          }
        }
      }

      // If no exact match, only return fuzzy match if score is reasonable (threshold of 2)
      // This prevents false positives for completely unrelated products
      if (bestMatch && bestScore <= 2) {
        // console.log('Fuzzy match found with score:', bestScore, 'for product:', bestMatch.name)
        return bestMatch
      }
      
      // console.log('No good match found. Best score was:', bestScore, 'for product:', bestMatch?.name || 'none')
      return null
    },
    async checkChannel() {
      if (process.client) {
        if (window.location.hostname.includes('catering') || window.location.href.includes('2001')) {
          this.$store.commit('setChannel', 'catering')
        } else {
          this.$store.commit('setChannel', 'default')
        }
        // console.log('href location: ', window.location.href)
        // console.log('active channel: ', this.channel)
      }
    },
    closeErrors() {
      this.$store.commit('setErrors', [])
    },
    setHeights() {
      const header = document.querySelector('header')
      const footer = document.querySelector('footer')
      
      if (header) {
        const headerHeight = header.getBoundingClientRect().height+'px'
        this.$store.commit('setHeaderHeight', headerHeight)
      }
      
      if (footer) {
        const footerHeight = footer.getBoundingClientRect().height+'px'
        this.$store.commit('setFooterHeight', footerHeight)
      }
    },
    handleLinkClick(event) {
      const target = event.target.closest('a');
      if (target && target.href && this.channel === 'catering') {
        // console.log(target, 'target')
        // console.log(target.href, 'target.href')
        const isExternal = !target.href.includes(window.location.host);
        // console.log(isExternal, 'isExternal')
        if (isExternal && target.href.includes('locations')) {
          // console.log('Go Go')
          window.open(target.href, '_blank');
          event.preventDefault();
        }
        else if (isExternal && this.order?.products?.length && this.goodToGo == false) {
          event.preventDefault();
          this.showExitModal();
        }
      }
    },
    showExitModal() {
      this.$refs.cateringExitModal.showModal = true;
    },

    goodToGoValue() {
      this.goodToGo = true;
    },
    handleDeepLinking() {
      // Prevent multiple calls to avoid race conditions
      if (this.deepLinkingProcessed) {
        // console.log('Deep linking already processed, skipping')
        return
      }
      
      // Handle deep linking from any page when product query param is present
      if (this.$route.query.product) {
        // console.log('Processing deep linking for product:', this.$route.query.product)
        this.deepLinkingProcessed = true
        
        // Reset deep linking state
        this.setDeeplinkProduct(null)
        this.setDeeplinkProductNotFoundAtLocation(false)
        this.setDeeplinkProductQuery(this.$route.query.product)

        const product = this.findProductByQuery(this.$route.query.product)
        if (product) {
          // Store the found product
          this.setDeeplinkProduct(product)
          
          // Determine the correct route based on context
          if (this.menu) {
            // Check if product exists in current location's menu
            const productExistsInLocation = this.checkProductExistsInMenu(product.sku, this.menu)
            // console.log('Product exists in location:', productExistsInLocation, 'for product:', product.name, 'SKU:', product.sku)
            if (productExistsInLocation) {
              // console.log('Redirecting to order product page')
              this.setDeeplinkProduct(null)
              this.setDeeplinkProductNotFoundAtLocation(false)
              this.$router.push(`/order/product?id=${product.sku}`)
            } else {
              // Product not available at current location, set flag and redirect to menu
              console.warn(`Product ${product.name} not available at current location`)
              this.setDeeplinkProductNotFoundAtLocation(true)
              this.$router.push('/menu')
            }
          } else {
            // No location set, use menu route
            this.$router.push(`/menu/product?id=${product.sku}`)
          }
        } else {
          // Product not found in any menu
          console.warn(`Product not found for query: ${this.$route.query.product}`)
          // Set a flag to show that the product wasn't found
          this.setDeeplinkProductNotFoundAtLocation(true)
          this.$router.push('/menu')
        }
      }
    },
    checkProductExistsInMenu(sku, menu) {
      if (!menu?.categories) {
        // console.log('No menu categories found')
        return false
      }
      
      // console.log('Checking for SKU:', sku, 'in menu with', menu.categories.length, 'categories')
      
      for (const category of menu.categories) {
        for (const product of category.products) {
          // console.log('Checking product SKU:', product.sku, 'against target:', sku)
          if (product.sku.toString() === sku.toString()) {
            // console.log('Found matching product:', product.name)
            return true
          }
        }
      }
      // console.log('No matching product found in current location menu')
      return false
    },
    async updateRoundupAmount() {
      const total = (this.order.totals.subtotal + this.order.totals.tax + this.order.totals.tip + this.order.totals.handoff - this.order.totals.discount)
      let amount = parseFloat((Math.ceil(total) - total).toFixed(2))
      if (total === 0) {
        amount = 1.00
      }
      await this.$axios({
        method: 'put',
        url: '/api/v2/carts/'+this.order.id+'/donations',
        data: {
          id: this.order.donations[0].id,
          amount: amount,
        }
      }).catch(err => {
        // console.log(err.m)
        this.$store.commit('setErrors', [err.response.data.message])
      })
    }
  },
  watch: {
    '$route.path'(e) {
      this.$store.commit('setErrors', [])
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
      this.locationRoute = this.$route.path === '/locations'
      this.checkChannel()
      // Reset deep linking flag when route changes
      this.deepLinkingProcessed = false
      // Don't reset deep linking state immediately - let components handle it
      // The state will be reset when the user closes the notification or navigates away
    },
    '$route.query': {
      handler(newQuery, oldQuery) {
        // Handle deep linking when query parameters change (including product parameter)
        if (newQuery.product && newQuery.product !== oldQuery?.product) {
          // console.log('Query parameter changed, triggering deep linking for product:', newQuery.product)
          this.deepLinkingProcessed = false // Reset flag to allow processing
          this.handleDeepLinking()
        }
      },
      deep: true
    },
    'order.totals': {
      handler() {
        if (this.order?.totals?.donations) {
          // Totals have changed update the donation amount
          this.updateRoundupAmount()
        }
      },
      deep: true
    },
    menu: {
      handler(newVal, oldVal) {
        // Only trigger deep linking when menu data BECOMES available (null -> menu)
        // Avoid triggering on menu updates when it already exists
        if (newVal?.categories && !oldVal?.categories && this.$route.query.product) {
          this.handleDeepLinking()
        }
      },
      deep: true,
      immediate: false
    }
  }
}
